<template>
  <div>
    <!-- breadcrumb start -->
    <breadcrumb-shop></breadcrumb-shop>
    <!-- breadcrumb end -->

    <!-- search area start -->
    <div class="shop-area mb-20">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="shop-banner mb-30">
              <div class="banner-image">
                <img class="banner-l" :src="slbanner" alt="">
                <img class="banner-sm" :src="slbannersm" alt="">
                <div class="banner-content text-center">
                  <p class="banner-text mb-30">Hurry Up! <br> Free Shipping All Order Over $99</p>
                  <router-link href="/shop" class="st-btn-d b-radius">Discover now</router-link>
                </div>
              </div>
            </div>
            <div class="product-lists-top">
              <div class="product__filter-wrap">
                <div class="row align-items-center">
                  <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
                    <div class="product__filter d-sm-flex align-items-center">
                      <div class="product__col">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                          <li class="nav-item" role="presentation">
                            <button class="nav-link" :class="{ active: activeTab === 'FourCol' }"  id="FourCol-tab" data-bs-toggle="tab"
                              data-bs-target="#FourCol" type="button" role="tab" aria-controls="FourCol"
                              
                              @click="activeTab = 'FourCol'" :aria-selected="activeTab === 'FourCol' ? 'true' : 'false'">
                              <i class="fas fa-th"></i>
                            </button>
                          </li>
                          <li class="nav-item" role="presentation">
                            <button class="nav-link" :class="{ active: activeTab === 'FiveCol' }"  id="FiveCol-tab" data-bs-toggle="tab" data-bs-target="#FiveCol"
                              type="button" tabindex="-1" @click="activeTab = 'FiveCol'" role="tab" aria-controls="FiveCol" :aria-selected="activeTab === 'FiveCol' ? 'true' : 'false'">
                              <i class="fas fa-list"></i>
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div class="product__result pl-60">
                        <p> Showing 1–{{ filteredProductsItems?.slice(startIndex, endIndex).length }} of {{
                          store.filteredProducts.length }} results</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
                    <div class="product__filter-right d-flex align-items-center justify-content-md-end">
                      <div class="product__sorting product__show-position ml-20">
                        <ui-nice-select :options="[
                          { value: 'default', text: 'Default Sorting' },
                          { value: 'high', text: 'Low to High' },
                          { value: 'low', text: 'High to Low' },
                          { value: 'new', text: 'New Added' },
                          { value: 'sale', text: 'On Sale' },
                        ]" name="Select Shorting" :default-current="0"
                          @onChange="handleSelectFilter" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="filteredProductsItems.length === 0" class="cartmini__empty text-center mt-80 mb-80">
              <img src="/images/product/empty-cart.png" alt="empty-cart-img" />
              <h4>Sorry! Couldn't find the product you were looking For!!!</h4>
              <p>Please check if you have misspelt something or try searching with other words.</p>
              <nuxt-link href="/shop" class="cart-btn">Continue Shopping</nuxt-link>
            </div>

            <div v-else>
              <div class="tab-content" id="productGridTabContent">
                <div class="tab-pane fade  " :class="{ 'show active': activeTab === 'FourCol' }" id="FourCol" role="tabpanel" aria-labelledby="FourCol-tab">
                  <div class="tp-wrapper">
                    <div class="row g-0">
                      <div v-for="item in filteredProductsItems.slice(startIndex, endIndex)" :key="item.id"
                        class="col-lg-3 col-md-4 col-sm-6">
                        <product-single :product="item" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" :class="{ 'show active': activeTab === 'FiveCol' }" id="FiveCol" role="tabpanel" aria-labelledby="FiveCol-tab">
                  <div class="tp-wrapper-2">
                    <product-list-item v-for="item in filteredProductsItems.slice(startIndex, endIndex)" :key="item.id"
                      :product="item" />
                  </div>
                </div>
              </div>
              <div class="tp-pagination text-center">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="basic-pagination pt-30 pb-30">
                      <ui-pagination :items-per-page="8" :data="filteredProductsItems || []"
                        @handle-paginate="handlePagination" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- search area end -->

    <!-- cta area start -->
    <cta-area></cta-area>
    <!-- cta area end -->
  </div>
</template>

<script>
import BreadcrumbShop from '@/components/breadcrumb/breadcrumb-shop.vue'
import slbanner from '@/assets/images/banner/sl-banner.jpg'
import slbannersm from '@/assets/images/banner/sl-banner-sm.png'
import UiPagination from '@/components/ui/pagination.vue'
import ProductSingle from '@/components/product/product-single-3.vue'
import ProductListItem from '@/components/product/product-list-item.vue'
import CtaArea from '@/components/cta/cta-area.vue'
// eslint-disable-next-line no-unused-vars
//import product_data from "@/data/product-data";
import { useProductFilterStore } from "@/stores/useProductFilterStore"

export default {
  name: "HeaderOne",
  components: {
    BreadcrumbShop,
    ProductSingle,
    CtaArea,
    ProductListItem,
    UiPagination
  },
  data() {
    const store = useProductFilterStore()
    return {
      slbanner,
      slbannersm,
      store,
      cate_menu: false,
      isSidebarOpen: false,
      category_data: [],
      product_data: [],
      searchText: '',
      category_value: '',
      category_options: [],
      filteredProductsItems: [],
      startIndex: 0,
      endIndex: 8,
      activeTab: 'FourCol'
    }
  },
  methods: {
    async fetchProducts() {
      try {
        // Extract query parameters from the route
        const { category, minPrice, maxPrice,searchText,categoryChild } = this.$route.query

        // Build query string dynamically
        const queryParams = new URLSearchParams()
        if (category) queryParams.append("category", category)
        if (minPrice) queryParams.append("minPrice", minPrice)
        if (maxPrice) queryParams.append("maxPrice", maxPrice)
        if (searchText) queryParams.append("searchText", searchText)
        if (categoryChild) queryParams.append("category_child", categoryChild)

        // Make Axios GET request with query parameters
        const response = await this.$axios.get(`/available-products?${queryParams.toString()}`)

        // Update product data and reset pagination
        this.product_data = response.data.data
        this.filteredProductsItems = response.data.data

        // Reset pagination indices
        this.startIndex = 0
        this.endIndex = 8

      } catch (error) {
        console.error("Error fetching products:", error)
      }
    },


    async fetchCategories() {
      try {
        const response = await this.$axios.get('/top-categories')
        this.category_data = response.data.rows
        console.log(response.data)
        this.category_options = this.category_data.map(item => ({
          value: item.cat_id,
          text: item.cat_name,
        }))
        this.category_options.unshift({ value: "all", text: "All Category" })
      } catch (error) {
        console.error("Error fetching categories:", error)
      }
    },
    renderCategoryName(name) {
      return name.replace('&', '<br/> &')
    },
    isLastItem(index) {
      return index === this.category_data.length - 1
    },
    formatUrl(slug) {
      return slug.replace(/\s+/g, '-').toLowerCase()
    },
    handlePagination(data, start, end) {
      this.startIndex = start // Update the indices for current page
      this.endIndex = end
    }
  },
  mounted() {
    this.fetchProducts()
    this.fetchCategories()
    // Watch for changes in route query parameters
    this.$watch(
      () => this.$route.query,
      () => {
        this.fetchProducts() // Fetch products again when query changes
      },
      { immediate: true } // Ensures it runs immediately on load
    )

  }
}
</script>

<style scoped>
/* Add styles for Home page */
.banner-image .banner-sm {
  position: absolute;
  right: 22%;
  top: 50%;
  transform: translateY(-50%);
}
</style>
